import { DeleteOutlined } from '@ant-design/icons';
import { Button, notification, Popconfirm } from 'antd';
import { useDeleteRelationItemMutation } from 'services';

/**
 * Satır aksiyonları: ilişkiyi silme.
 * Sorun durumu, "Sorun Var/Yok" sütunundaki hücre dropdown'ından değiştirilir.
 * @param {Object} props
 * @param {string} props.id - İlişki öğesinin ID'si
 */
function TableActions({ id }) {
  const [deleteRelationItem] = useDeleteRelationItemMutation();

  async function handleDelete() {
    const { error } = await deleteRelationItem({ id });
    if (error) {
      return notification.error({
        message: 'İlişki Maddesi Silme Hatası',
        description: error.data.message,
      });
    }

    notification.success({
      message: 'İlişki Maddesi Başarıyla Silindi',
    });
  }

  return (
    <Popconfirm
      title="Bu ilişki maddesini silmek istediğinize emin misiniz?"
      onConfirm={handleDelete}
      okText="Evet"
      cancelText="Hayır"
    >
      <Button
        icon={<DeleteOutlined />}
        size="small"
      />
    </Popconfirm>
  );
}

export default TableActions;
